<template>
    <b-textarea ref="textarea"
                class="grid-title-textarea"
                :id="id || null"
                :name="name || null"
                :value="value"
                :placeholder="placeholder"
                :disabled="disabled"
                rows="1"
                no-resize
                @input="onInput">
    </b-textarea>
</template>

<script>
    export default {
        name: 'grid-title-textarea',
        props: {
            value: {
                type: String,
                default: ''
            },
            id: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            value() {
                this.$nextTick(this.resize);
            }
        },
        mounted() {
            this.resize();
        },
        methods: {
            onInput(val) {
                this.$emit('input', val);
                this.$nextTick(this.resize);
            },
            resize() {
                const el = this.$refs.textarea && this.$refs.textarea.$el;
                if (!el)
                    return;
                el.style.height = 'auto';
                el.style.height = `${el.scrollHeight + 4}px`;
            }
        }
    };
</script>

<style scoped>
    .grid-title-textarea {
        width: 100%;
        min-width: 0;
        overflow: hidden;
    }
</style>
